import React from 'react';

import { GridRightPanelProps } from 'components/grid/grid-types';
import { ArchivalUnitFavourite } from 'modules/archival-unit/archival-unit-favourite';
import { ArchivalUnitDownload } from 'modules/archival-unit/archival-unit-download';
import { ArchivalUnitAddToCart } from 'modules/archival-unit/action-buttons/add-to-cart';
import { GridRightPanelCart } from 'modules/archival-unit/action-buttons/cart-info';
import { ArchivalUnitQuote } from 'modules/archival-unit/archival-unit-quote';
import { renderActionButtons } from 'components/grid/right-panel/action-buttons-factory';

import { eadConfig } from './ead-grid-config';

const archivalAidChildrenActionButtons = [
  { id: 'favourite', Component: ArchivalUnitFavourite },
  { id: 'download', Component: ArchivalUnitDownload },
  { id: 'add-to-cart', Component: ArchivalUnitAddToCart },
  { id: 'grid-cart', Component: GridRightPanelCart },
  { id: 'quote', Component: ArchivalUnitQuote },
];

export const ArchivalAidChildrenActionButtons = (
  props: GridRightPanelProps
) => {
  const { isEad } = props;

  const EadActionButtons = eadConfig.ActionButtons ?? (() => <></>);

  if (isEad) {
    return <EadActionButtons {...props} />;
  }

  return renderActionButtons(archivalAidChildrenActionButtons, props);
};
